import { spaceCadet } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  gap: 8,
  alignItems: 'center',

  '& .MuiButton-root': {
    fontWeight: 600,
    color: spaceCadet[500],
    padding: '6px 8px',
    lineHeight: '20px',
    '&:not(.cta)': {
      minWidth: 'unset',
      fontSize: 16,
      padding: 4,
      '& svg': {
        fontSize: 'inherit',
        color: 'inherit',
      },
    },
  },
});

export default StyledBox;
